import * as SAPui from "@ui5/webcomponents-react";

export default SAPui;